module.exports = __webpack_public_path__ + "img/Germantown_Grille@2x.d2207fc1.png";